import { DataBean } from "../DataBean";

export class AppointmentManualPdf extends DataBean {
  public async getAppointmentManualPdfCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "java.util.List_getAppointmentManualPdfCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteAppointmentManualPdf(
    idappointmentmanualpdf: number
  ): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "boolean_deleteAppointmentManualPdf_Number",
      [idappointmentmanualpdf]
    );
  }

  public async getAppointmentManualByIDEmployee(
    idEmployee: number,
    year: number,
    month: number
  ): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.advantage.shared.Report_getAppointmentManualByIDEmployee_Number_Number_Number",
      [idEmployee, year, month]
    );
  }

  public async updateAppointmentManualPdf(bean): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.AppointmentManualPdf_updateAppointmentManualPdf_com.orange.people.talent.bean.AppointmentManualPdf",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.people.talent.bean.AppointmentManualPdf",
        },
      ]
    );
  }
}
